import { AuthFlowCard } from '@/features/register/AuthFlowCard';
import { createFileRoute } from '@tanstack/react-router';

function RegisterPage() {
  return <AuthFlowCard useCase="register" />;
}

export const Route = createFileRoute('/_auth/register')({
  component: RegisterPage,
});





